/* Trick or Print — la home. Tutto ciò che si vede qui viene da catalogo.js. */

/* ----------------------------------------------------------------- i tre volumi */
function volumi() {
  $("#volumi").innerHTML = CAT().volumi.map(v => `<article class="card rivela">
    <div class="foto"><span class="etichetta">Ages ${v.eta}</span>
      <img src="${ASSET(`assets/img/mockup/${v.id}.jpg`)}" alt="${v.nome}" loading="lazy"></div>
    <div class="corpo">
      <h3>${v.nome}</h3>
      <div class="eta">Ages ${v.eta} · ${v.pagine} coloring pages</div>
      <p class="piccolo tenue" style="margin:10px 0 14px">${v.testo}</p>
      <ul>${v.voci.map(x => `<li>${x}</li>`).join("")}</ul>
    </div></article>`).join("");
}

/* ------------------------------------------------------------- selettore d'età */
function selettore() {
  const V = CAT().volumi;
  $("#selettore-eta").innerHTML = V.map((v, i) =>
    `<button class="tab ${i === 0 ? "attiva" : ""}" data-i="${i}">${v.eta} years</button>`).join("");
  const mostra = i => {
    const v = V[i];
    $("#risposta-eta").innerHTML = `<div class="risposta">
      <h3>${v.nome} — ${v.pagine} pages just for ${v.eta}</h3>
      <p class="tenue">${v.testo}</p>
      <ul class="tenue piccolo due-colonne">
        ${v.voci.map(x => `<li style="margin-bottom:6px">· ${x}</li>`).join("")}</ul>
      <p class="mini tenue" style="margin:10px 0 0">It comes with the other two ages in the same download —
        there's no version that gives you only one.</p></div>`;
    $$("#selettore-eta .tab").forEach((b, k) => b.classList.toggle("attiva", k === i));
  };
  $$("#selettore-eta .tab").forEach(b => b.onclick = () => mostra(+b.dataset.i));
  mostra(0);
}

/* ═══════════════════════════════════════════════════ IL BLOCCO DELL'OFFERTA
   Mockup + nome + stelline + i punti che agganciano + gli extra.
   ⛔ I punti sono editoriali, ma ogni cifra che compare qui dentro viene da
      catalogo.js (generato dai file veri): non se ne scrive nessuna a mano. */
const PUNTI = {
  "halloween-coloring-collection": {
    stat: () => [[prod("halloween-coloring-collection").pagine, "coloring pages"],
                 [3, "ebooks"], ["3–12", "years old"]],
    forti: () => {
      const C = prod("halloween-coloring-collection");
      // ⛔ niente cifre scritte a mano: si pescano dalle voci vere, generate dai PDF
      const scene = (C.voci.find(x => x.includes("full-page scenes")) || "").replace(" Halloween settings", " settings");
      return [
      [`${mille(C.pagine)} coloring pages, split by age`, "3 ebooks",
       "Ages 3–5, 6–8 and 9–12 each get their own file, with the age printed on the cover. Nobody colors the wrong page."],
      [scene.charAt(0).toUpperCase() + scene.slice(1), "no repeats",
       "Not one of them is another page recolored. Every page was compared against every other page before it shipped."],
      ["Every page counted, not estimated", "page 2 of each file",
       "Each ebook opens with a line-by-line contents page, and the lines add up to the total. Read it before you buy."],
      ["Vector line art, drawn in code", "clean at any size",
       `Prints black on white at exactly the same weight on page 1 and on page ${mille(C.pagine)}, and it's easy on a cartridge`],
      ["The same eight friends, all the way through", "Spooky Friends",
       "Pip, Luna, Boo and five others turn up in the pages, the stories and the games. A folder of bought clip art can't do that."]
    ]; },
    extra: [
      ["Print it again every October", "no expiry",
       "Yours to keep. Nothing ships, nothing renews, there is no subscription."],
      ["Found a broken page? Fixed in 24 hours", "re-issued free",
       "We fix the file and send you the corrected version — you don't buy it twice."],
      ["Broken page fixed, or your money back", "14 days",
       "We correct the file and re-send it. If it can't be corrected, we refund you — within 14 days of buying."]
    ]
  },
  "complete-halloween-vault": {
    stat: () => [[CAT().totali.prodotti, "ebooks"], [CAT().totali.pdf, "PDFs"],
                 [CAT().totali.pagine_uniche, "unique pages"]],
    forti: () => {
      const V = prod("complete-halloween-vault"), C = prod("halloween-coloring-collection");
      return [
      ["Every ebook in the shop, one download", `${mille(CAT().totali.pagine_uniche)} unique pages`,
       `All ${CAT().totali.prodotti} of them, ${CAT().totali.pdf} PDFs. ${V.nota_pagine}`],
      ["The full Coloring Collection, by age", `${mille(C.pagine)} pages`,
       "Ages 3–5, 6–8 and 9–12, each in its own ebook. The part most people buy on its own."],
      ["An escape room and a murder mystery", "7 puzzles · 12 players",
       "The Midnight Candy Mystery for kids, Murder at the Midnight Masquerade for teens and grown-ups. Nobody has to act."],
      ["The Classroom Party Edition", "grades K–5",
       "Three timed plans — 20, 30 and 45 minutes — and every page they call for, bingo cards included."],
      ["Pumpkin stencils where the peel holds", "4 levels",
       "Checked in the geometry, not just drawn. Free stencils collapse at the third cut; these were built not to."]
    ]; },
    extra: [
      ["Classroom & group licence", "included",
       "Print it for every child in your class, every year. It comes inside the Classroom Party Edition."],
      ["Free fixes, re-issued to every owner", "24 hours",
       "One broken page and everyone who bought it gets the corrected file."],
      ["Broken page fixed, or your money back", "14 days",
       "Same promise on all twelve: we fix it, and if it can't be fixed we refund you."]
    ]
  }
};

const rigaPunto = ([titolo, tag, testo], omaggio) => `<li class="punto">
  <span class="spunta">✓</span>
  <h4>${titolo}${omaggio ? `<span class="omaggio">bonus</span>` : ""}</h4>
  <span class="tag">${tag}</span>
  <p>${testo}</p></li>`;

function acquisto() {
  const core = prod("halloween-coloring-collection"), vault = prod("complete-halloween-vault");
  // il confronto si fa sui prezzi IN VIGORE: mai un risparmio gonfiato
  const pezzi = CAT().prodotti.filter(p => p.ruolo !== "vault" && p.id !== "candy-free-treats-mini-books")
    .reduce((s, p) => s + prezzoOra(p.prezzo), 0);
  let scelto = core.id;

  const dipingi = () => {
    const p = prod(scelto), ora = prezzoOra(p.prezzo), sc = attivo() && ora < p.prezzo;
    const B = PUNTI[p.id], isVault = p.ruolo === "vault";

    $("#offerta").innerHTML = `
      <div class="off-sx">
        <div class="off-scelte"><div class="due-scelte">
          <button class="${scelto === core.id ? "attiva" : ""}" data-id="${core.id}">The 3 coloring ebooks
            <small>${soldi(prezzoOra(core.prezzo))} · ages 3–12</small></button>
          <button class="vault-scelta ${isVault ? "attiva" : ""}" data-id="${vault.id}">
            <span class="nastro">Best value · save ${soldi(pezzi - prezzoOra(vault.prezzo))}</span>
            The Complete Vault
            <small><s>${soldi(pezzi)}</s> <b>${soldi(prezzoOra(vault.prezzo))}</b>
              · all ${CAT().totali.prodotti} ebooks</small></button>
        </div></div>

        <div class="off-foto"><div class="scatto"><img src="${img(p)}" alt="${p.nome}" loading="lazy"></div></div>

        <div class="off-prova">
        <div class="stat3">${B.stat().map(([n, t]) =>
          `<div><b>${n}</b><span>${t}</span></div>`).join("")}</div>

        </div>

        <div class="off-prezzo">
        <div class="cartellino">
          <span class="ora">${soldi(ora)}</span>
          ${sc ? `<span class="prima">${soldi(p.prezzo)}</span>
                  <span class="meno">−${Math.round(OFFERTA.sconto * 100)}%</span>` : ""}
        </div>
        ${isVault ? `<p class="mini arancio centro" style="margin:-8px 0 16px">
          Bought separately today, the same ebooks cost ${soldi(pezzi)}. You save ${soldi(pezzi - ora)}.</p>` : ""}

        <button class="btn pieno" id="btn-aggiungi">
          ${isVault ? "Get the whole Vault" : "Get all 3 ebooks"} — ${soldi(ora)}</button>

        <p class="sicuro"><b>Instant download</b> · US Letter PDF (8.5 × 11 in) · Print at home</p>
        <p class="sicuro" style="margin-top:6px">14-day fix-or-refund · Yours to keep · No subscription</p>
        </div>
      </div>

      <div class="off-dx">
        <div class="off-testa">
        <h3 style="font-size:clamp(1.5rem,2.6vw,1.95rem);margin-bottom:.2em">${p.nome}</h3>
        ${valutazione()}
        </div>

        <div class="off-lista">
        <ul class="punti">${B.forti().map(v => rigaPunto(v, false)).join("")}</ul>

        <p class="capo">The extras — free with it</p>
        <ul class="punti extra">${B.extra.map(v => rigaPunto(v, true)).join("")}</ul>

        <div class="somma"><b>Everything above, one download</b>
          <span>${isVault ? CAT().totali.pdf : p.pdf_n} PDF files · ${p.pagine} pages</span></div>
        </div>
      </div>`;

    $$("#offerta .due-scelte button").forEach(b => b.onclick = () => { scelto = b.dataset.id; dipingi(); });
    $("#btn-aggiungi").onclick = () => Carrello.aggiungi(scelto);
  };
  dipingi();
}

/* ------------------------------------------------- il video che sfoglia le pagine */
function sfoglia() {
  const V = CAT().volumi, vid = $("#video-sfoglia");
  if (!vid) return;
  if (!V.some(v => ASSET(`assets/video/${v.id}.mp4`))) {
    const s = document.getElementById("sfogliare");
    if (s) s.remove();
    return;
  }
  $("#tabs-video").innerHTML = V.map((v, i) =>
    `<button class="tab ${i === 0 ? "attiva" : ""}" data-i="${i}">${v.nome}</button>`).join("");
  const play = i => {
    const v = V[i];
    vid.src = ASSET(`assets/video/${v.id}.mp4`);
    vid.poster = ASSET(`assets/img/mockup/${v.id}.jpg`);
    vid.play().catch(() => {});
    $("#video-did").innerHTML = `<b>${v.nome}</b> — ages ${v.eta}, ${v.pagine} pages, page by page.`;
    $$("#tabs-video .tab").forEach((b, k) => b.classList.toggle("attiva", k === i));
  };
  $$("#tabs-video .tab").forEach(b => b.onclick = () => play(+b.dataset.i));
  play(0);
}

/* ══════════════════════════════════════════ LA PAGINA MIGLIORE DI OGNI PRODOTTO
   Scelta guardando il provino di tutte e 42 (28/09): delle tre rese per prodotto,
   molte sono muri di testo che in miniatura non dicono niente. Qui sta quella che
   si capisce in un secondo e che fa venire voglia di stamparla. */
const MIGLIORE = {
  "little-spooks-coloring-pages":        [1, "Ages 3–5 · lines thick enough for a small hand to stay inside"],
  "spooky-kids-coloring-pages":          [3, "Ages 6–8 · a whole scene, not one object floating on white"],
  "brave-explorers-coloring-pages":      [2, "Ages 9–12 · the kind of page that eats a whole evening"],
  "puzzle-and-activity-pack":            [2, "Mazes, word searches, sudoku — every maze with exactly one way out"],
  "halloween-party-kit":                 [1, "The rules are printed on the page. No phone, no scrolling"],
  "midnight-candy-mystery-escape-room":  [2, "Seven puzzles, one padlock code, an easier twin for the little ones"],
  "editable-halloween-invitations":      [3, "Type the details on a computer, print, hand them out"],
  "teen-and-tween-party-pack":           [2, "For the age that finds everything cringe"],
  "classroom-party-edition":             [1, "Grades K–5 · a plan that really fits in twenty minutes"],
  "spooky-friends-story-pack":           [2, "Twelve read-aloud stories, and twelve pages to color after"],
  "31-days-of-halloween":                [3, "One pumpkin colored in every night, all October"],
  "candy-free-treats-mini-books":        [2, "Ten mini books from ten sheets of paper. No candy"],
  "murder-at-the-midnight-masquerade":   [1, "Twelve guests, and nobody has to act"],
  "pumpkin-carving-stencils":            [3, "Four levels — and the peel stays in one piece"]
};
const pagina = f => ASSET(`assets/img/pages/${f}-${MIGLIORE[f][0]}.jpg`);

/* ------------------------- «Every page counted»: la prova accanto a ciò che promette
   La sola pagina dell'indice e' onesta ma non convince nessuno: e' un elenco.
   Accanto ci va una pagina vera dello stesso file — questo dice e questo mantiene. */
function carosello() {
  const P = CAT().prodotti.filter(p => p.ruolo !== "vault");
  const file = P.flatMap(p => p.file.map(f => ({ f, nome: p.nome, id: p.id })));
  let i = 0;
  $("#carosello").innerHTML = `<button class="freccia" id="c-prev" aria-label="Previous">‹</button>
    <div class="coppia">
      <figure class="telaio"><img id="c-indice" src="" alt="The contents page">
        <figcaption>What it says it has</figcaption></figure>
      <figure class="telaio"><img id="c-pagina" src="" alt="A real page">
        <figcaption>…and one of them, for real</figcaption></figure>
    </div>
    <button class="freccia" id="c-next" aria-label="Next">›</button>`;
  const va = k => {
    i = (k + file.length) % file.length;
    const x = file[i];
    $("#c-indice").src = ASSET(`assets/img/inside/${x.f}.jpg`);
    $("#c-pagina").src = pagina(x.f);
    $("#carosello-did").innerHTML =
      `<b class="giallo">${x.nome}</b> — ${MIGLIORE[x.f][1]}
       <span class="tenue">· ${i + 1} of ${file.length}</span>`;
  };
  $("#c-prev").onclick = () => va(i - 1);
  $("#c-next").onclick = () => va(i + 1);
  va(0);
}

/* ------------------------------------------------------------------ pagine vere */
function pagineVere() {
  const scelte = ["brave-explorers-coloring-pages", "little-spooks-coloring-pages",
                  "spooky-kids-coloring-pages", "31-days-of-halloween",
                  "puzzle-and-activity-pack", "pumpkin-carving-stencils"];
  const nome = f => CAT().prodotti.find(p => p.file.includes(f))?.nome
                 || CAT().volumi.find(v => v.id === f)?.nome || f;
  $("#pagine-vere").innerHTML = scelte.map(f => `<figure class="card rivela" style="margin:0">
    <div class="foto" style="background:#fff"><img src="${pagina(f)}" alt="${nome(f)}" loading="lazy"></div>
    <figcaption class="corpo" style="padding:16px 20px">
      <b class="giallo">${nome(f)}</b><div class="piccolo tenue">${MIGLIORE[f][1]}</div></figcaption></figure>`).join("");
}

/* ------------------------------------ un assaggio degli altri, poi si va su shop.html */
function assaggio() {
  const tutti = CAT().prodotti.filter(p => p.ruolo !== "core" && p.ruolo !== "vault");
  $("#quanti-altri").innerHTML =
    `${tutti.length} more ebooks, grouped<br>by the moment you need them`;
  const altri = tutti.slice(0, 6);
  $("#assaggio").innerHTML = altri.map(p =>
    `<a href="/products/${HANDLE(p.id)}" title="${p.nome}">
       <img src="${img(p)}" alt="${p.nome}" loading="lazy"></a>`).join("");
}

/* ------------------------------------------------------------------------ Vault */
function vault() {
  const v = prod("complete-halloween-vault");
  const pezzi = CAT().prodotti.filter(p => p.ruolo !== "vault" && p.id !== "candy-free-treats-mini-books")
    .reduce((s, p) => s + prezzoOra(p.prezzo), 0);
  const ora = prezzoOra(v.prezzo);
  $("#blocco-vault").innerHTML = `<div class="acquisto" style="align-items:center">
    <div><img src="${ASSET(`assets/img/mockup/complete-halloween-vault.jpg`)}" alt="All fourteen PDFs"
         style="border-radius:16px" loading="lazy"></div>
    <div>
      <p class="occhiello">One download, the whole October</p>
      <h2 style="margin-bottom:.3em">The Complete Halloween Vault</h2>
      <p class="tenue">All ${CAT().totali.prodotti} ebooks, ${CAT().totali.pdf} PDFs,
        <b class="giallo">${mille(v.pagine)} unique pages</b> of content.</p>
      <p class="mini tenue">${v.nota_pagine} We ran that comparison across every file in the shop,
        page against page — the number you see is what's left after it.</p>
      <div style="display:flex;align-items:baseline;gap:14px;margin:18px 0 6px">
        <span class="tenue" style="text-decoration:line-through;font-size:1.05rem">${soldi(pezzi)}</span>
        <span style="font-family:Fredoka,sans-serif;font-size:2.4rem;color:var(--giallo)">${soldi(ora)}</span>
        <span class="arancio">save ${soldi(pezzi - ora)}</span>
      </div>
      <p class="mini tenue">That's the price of the same ebooks bought one by one today, added up. No invented “value”.</p>
      <button class="btn" style="margin-top:14px" onclick="Carrello.aggiungi('${v.id}')">
        Add the Vault — ${soldi(ora)}</button>
    </div></div>`;
}

/* ------------------------------------------------------------------------ amici */
function amici() {
  $("#lista-amici").innerHTML = CAT().amici.map(a => `<div class="amico rivela">
    <img src="${ASSET(`assets/img/friends/${a.id}.png`)}" alt="${a.nome}" loading="lazy">
    <h4>${a.nome} <span>(${a.pron})</span></h4><p>${a.testo}</p></div>`).join("");
}

/* ------------------------------------------------------------------------ varie */
function rifiniture() {
  const core = prod("halloween-coloring-collection"), ora = prezzoOra(core.prezzo);
  $("#hero-pagine").textContent = mille(core.pagine);
  $("#hero-compra").textContent = `Get all 3 ebooks — ${soldi(ora)}`;
  $("#hero-compra").onclick = () => Carrello.aggiungi(core.id);
  /* ⛔ Il barrato e' il prezzo PIENO, non il prezzo di listino: su Shopify lo sconto
     e' il «compare at price» e arriva come `pieno`, quindi `prezzoOra` non toglie piu'
     niente e i due numeri uscivano identici («€11.99 €11.99»). Senza `pieno` — il sito
     locale, dove lo sconto lo applica prezzoOra — si ricade sul prezzo, come prima. */
  $("#hero-listino").innerHTML = attivo()
    ? `<span class="vecchio">${soldi(core.pieno || core.prezzo)}</span><span class="nuovo">${soldi(ora)}</span>
       <span class="mini tenue">for all three ebooks</span>`
    : `<span class="nuovo">${soldi(ora)}</span><span class="mini tenue">for all three ebooks</span>`;
  bandaCTA("#cta-pagine");
  bandaCTA("#cta-promessa");
  bandaCTA("#cta-finale");
  // sul ponte il Vault viene prima: e' il modo di prendere tutti gli altri in un colpo
  bandaCTA("#cta-ponte", { vaultPrima: true, primo: "Just the 3 coloring ebooks",
                           secondo: `Get all ${CAT().totali.prodotti} in the Vault` });
  const g = giorniA(HALLOWEEN);
  $("#conto-finale").innerHTML = `Halloween is in <b>${g} days</b>, and it falls on a Saturday.`;
  $$(".onda").forEach(o => { if (!o.innerHTML.trim()) o.innerHTML = onda().replace(/^<div[^>]*>|<\/div>$/g, ""); });
}

/* ------------------------------------------------------------------ recensioni */
function recensioni() {
  const r = REC();
  if (!r) return;

  $("#rec-riepilogo").innerHTML = `
    <div class="centro">
      <div class="grosso">${r.punteggio.toFixed(2)}</div>
      <div class="su">out of 5</div>
    </div>
    <div class="dettaglio">
      <div class="stelle" style="--p:${(r.punteggio / 5 * 100).toFixed(1)}%">
        <span class="vuote">★★★★★</span><span class="piene">★★★★★</span></div>
      <div class="n">${mille(r.numero)} verified reviews</div>
      <div class="f">${r.fonte}</div>
    </div>`;

  /* ⛔ L'avviso in pagina e' stato tolto su richiesta di Manuel (28/09): le recensioni
     vere arrivano da lui. Finche' `esempi` e' true restano SEGNAPOSTO scritti da Claude,
     e l'unico promemoria e' in console e in STATO.md §9.1. */
  if (r.esempi)
    console.warn("⛔ RECENSIONI SEGNAPOSTO in pagina — sostituirle in assets/js/recensioni.js "
               + "e mettere esempi:false prima di pubblicare (STATO.md §9.1)");

  $("#rec-lista").innerHTML = r.voci.map((v, i) => {
    const p = v.prodotto ? prod(v.prodotto) : null;
    return `<article class="recensione rivela${i >= 3 ? " oltre" : ""}">
      ${stelle(v.stelle)}
      ${v.titolo ? `<h4>${v.titolo}</h4>` : ""}
      <p>${v.testo}</p>
      <div class="rec-fondo">
        <div><div class="chi">${v.nome}</div><div class="dove">${v.luogo} · ${v.data}</div></div>
        <span class="ok">✓ Verified</span>
      </div>
      ${p ? `<a href="/products/${HANDLE(p.id)}" style="display:flex;align-items:center;gap:10px;margin-top:12px">
        <img src="${img(p)}" alt="" loading="lazy"
             style="width:42px;height:42px;object-fit:cover;border-radius:8px;flex:none">
        <span class="rec-prod">on ${p.nome}</span></a>` : ""}
    </article>`;
  }).join("");

  /* ⛔ Il pulsante «Read all N reviews» e' stato tolto il 29/09, con l'`if` che lo
     reggeva: le recensioni adesso scorrono da sole, e un pulsante che apre lo
     stesso elenco gia' visibile e' solo un ostacolo in piu'. */
}

function contenutoHome() {
  volumi(); selettore(); acquisto(); sfoglia(); carosello(); pagineVere();
  assaggio(); vault(); recensioni(); amici(); rifiniture();
}
